module.exports = __webpack_public_path__ + "img/2019.04.66479211.jpg";